import { jsx as _jsx } from "react/jsx-runtime";
import { Switch as MUISwitch, switchClasses as MUIswitchClasses } from '@mui/material';
import { styled } from '@mui/system';
const Switch = styled((props) => (_jsx(MUISwitch, Object.assign({ focusVisibleClassName: '.Mui-focusVisible', disableRipple: true }, props))))(({ theme, size, color }) => {
    let width = 32;
    let height = 20;
    if (size === 'small') {
        width = 24;
        height = 16;
    }
    if (size === 'large') {
        width = 40;
        height = 24;
    }
    const margin = 2;
    const thumb = height - margin * 2;
    return {
        width,
        height,
        padding: 0,
        [`& .${MUIswitchClasses.switchBase}`]: {
            padding: 0,
            margin,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: `translateX(${width - thumb - margin * 2}px)`,
                [`& + .${MUIswitchClasses.track}`]: {
                    backgroundColor: color,
                    border: 0,
                    opacity: 1,
                },
            },
            [`&.Mui-disabled + .${MUIswitchClasses.track}`]: {
                backgroundColor: '#E0E0E0',
                opacity: 1,
            },
            [`&.Mui-disabled .${MUIswitchClasses.thumb}`]: {
                backgroundColor: '#B2B2B2',
            },
            [`&.Mui-focusVisible .${MUIswitchClasses.thumb}`]: {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
        },
        [`& .${MUIswitchClasses.thumb}`]: {
            backgroundColor: '#FFFFFF',
            boxShadow: 'none',
            boxSizing: 'border-box',
            width: thumb,
            height: thumb,
        },
        [`& .${MUIswitchClasses.track}`]: {
            borderRadius: height / 2,
            backgroundColor: '#CEDDF3',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    };
});
export default Switch;
